"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/reTitle/index"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RealTitle: _index.default
  },
  data: function data() {
    return {
      backPath: '/teacherIndex',
      titleInfo: {
        sec: "历年作品展示"
      },
      awardsActNum: 0,
      itemsActNum: 0,
      hisWorksTypeInfo: {
        title: ["2022年大赛视频"],
        awards: ["一等奖", "二等奖", "三等奖"]
      },
      list: [
        // {
        //   imgSrc: "",
        //   title: "《人间失格》"
        // }
      ]
    };
  },
  methods: {
    items: function items(e) {
      this.itemsActNum = e;
    },
    awards: function awards(e) {
      this.awardsActNum = e;
    },
    jump: function jump(e) {
      console.log(e);
      this.$router.push("/yearViewDetail");
    }
  }
};